'use client'

import { Dialog } from '@vinted/web-ui'

import { markAsDeliveredToSender } from '@marketplace-web/conversation-shipping/conversation-shipping-data'
import { reloadPage } from '@marketplace-web/shared/browser'

import { useTranslate } from '@marketplace-web/shared/i18n'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'

import { ClickableElement } from 'constants/tracking/clickable-elements'
import { clickEvent } from '_libs/common/event-tracker/events'

type Props = {
  transactionId: number
  isOpen: boolean
  onClose: () => void
  screen: string
}

const MarkAsDeliveredToSenderConfirmationModal = ({
  transactionId,
  isOpen,
  onClose,
  screen,
}: Props) => {
  const translate = useTranslate('conversation.tracking_details.mark_as_delivered_to_sender')
  const { track } = useTracking()

  function trackMarkAsDeliveredClick() {
    const targetDetails = {
      transaction_id: transactionId,
    }

    track(
      clickEvent({
        screen,
        target: ClickableElement.MarkAsReceived,
        targetDetails: JSON.stringify(targetDetails),
      }),
    )
  }

  async function handleMarkAsDeliveredClick() {
    trackMarkAsDeliveredClick()
    await markAsDeliveredToSender(transactionId)
    onClose()
    reloadPage()
  }

  return (
    <Dialog
      show={isOpen}
      defaultCallback={onClose}
      title={translate('title')}
      body={translate('body')}
      actions={[
        {
          text: translate('confirm'),
          callback: handleMarkAsDeliveredClick,
          style: Dialog.ActionStyling.Filled,
        },
        {
          text: translate('close'),
          callback: onClose,
          style: Dialog.ActionStyling.Flat,
        },
      ]}
    />
  )
}

export default MarkAsDeliveredToSenderConfirmationModal
